import React from "react";
import { Mark } from "components/icons/Mark";

import Dashboard from "views/partner/dashboard";
import TasksList from "views/partner/tasks/TasksList";
import TaskDetail from "views/partner/tasks/TaskDetail";
import PartnerProfile from "views/partner/profile";
import Support from "views/partner/support";
import SupportTicketDetail from "views/partner/support/SupportTicketDetail";
import SignIn from "views/auth/SignIn";

import {
  MdHome,
  MdListAlt,
  MdPerson,
  MdHelpOutline,
  MdLock,
} from "react-icons/md";

const routes = [
  {
    name: "Dashboard",
    layout: "/partner",
    path: "dashboard",
    icon: <Mark as={MdHome} w="20px" h="20px" />,
    component: <Dashboard />,
  },
  {
    name: "Pedidos",
    layout: "/partner",
    path: "orders",
    icon: <Mark as={MdListAlt} w="20px" h="20px" />,
    component: <TasksList />,
  },
  {
    name: "Detalhe do Pedido",
    layout: "/partner",
    path: "orders/:taskId",
    icon: <Mark as={MdListAlt} w="20px" h="20px" />,
    component: <TaskDetail />,
    hidden: true,
  },
  {
    name: "Perfil",
    layout: "/partner",
    path: "profile",
    icon: <Mark as={MdPerson} w="20px" h="20px" />,
    component: <PartnerProfile />,
  },
  {
    name: "Detalhe do chamado",
    layout: "/partner",
    path: "support/:ticketId",
    icon: <Mark as={MdHelpOutline} w="20px" h="20px" />,
    component: <SupportTicketDetail />,
    hidden: true,
  },
  {
    name: "Suporte",
    layout: "/partner",
    path: "support",
    icon: <Mark as={MdHelpOutline} w="20px" h="20px" />,
    component: <Support />,
  },
  {
    name: "Entrar",
    layout: "/auth",
    path: "sign-in",
    icon: <Mark as={MdLock} w="20px" h="20px" />,
    component: <SignIn />,
    hidden: true,
  },
];

export default routes;
